import styled from 'styled-components'
import { colors } from '@app/themes'

export const RevealButton = styled.span`
  font-size: 12px;
  padding: 5px 5px;
  background: ${colors.LightGray};
  color: ${colors.NinjaRed};
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  margin-right: 8px;

  &:hover {
    background: ${colors.Silver};
  }
`

export const AddressContainer = styled.span`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
`
